import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import PerfilFormSections from "./PerfilFormSections.js";

var groupLoaded = false;
class Detail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            padre: null,
            permisos_checked: [],
            permisos_disabled: []
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
    }

    ResetForm() {
        this.setState({
            activeTab: 1,
            padre: null,
            permisos_checked: [],
            permisos_disabled: []
        });
        groupLoaded = false;
    }

    setSelects(data) {
        if (data.padre_id) {
            this.setState({
                padre: data.padre_id,
                permisos_checked: data.Permisos
            });
        } else {
            this.setState({
                padre: 0,
                permisos_checked: data.Permisos
            });
        }
    }

    groupChanged(value) {
        this.setState({
            padre: value.pk,
            permisos_disabled: value.permisos,
            permisos_checked: []
        });
    }

    groupLoaded(value) {
        if (value != undefined && !groupLoaded) {
            groupLoaded = true;
            this.setState({
                permisos_disabled: value.permisos
            });
        }
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.usuarios.perfiles.detail}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Perfil de Usuario"}
                buttonTitle={"Ver Perfil de Usuario"}
                buttonIcon={"fa fa-search fa-lg"}
                saveButton={false}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.ResetForm()}
                className={"ui-modal-dialog ui-modal-lg"}
            >
                <div className="ui-form">
                    <PerfilFormSections
                        disabled={true}
                        permisosMode={"detail"}
                        padre={this.state.padre}
                        permisosChecked={this.state.permisos_checked}
                        permisosDisabled={this.state.permisos_disabled}
                        onPadreLoaded={(value) => this.groupLoaded(value)}
                        onPadreChange={(value) => this.groupChanged(value)}
                        onPermisosChange={(value) => this.setState({ permisos_checked: value })} />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Perfiles/Detail.js